import { selectAmounts } from 'store/autoReducers';
import { useSelector } from 'store/utils';

const useDefaultAmountForReplenishment = (): number => {
    const { recommendedAmount } = useSelector(selectAmounts);
    const availableBalance = useSelector((state) => state.balance?.availableBalance);

    const amountForReplenishmentAbs = Math.abs(availableBalance);
    const isAvailableBalanceMoreThanRecommendedDeposit =
        availableBalance < 0 && amountForReplenishmentAbs > recommendedAmount;

    return isAvailableBalanceMoreThanRecommendedDeposit ? amountForReplenishmentAbs : recommendedAmount;
};

export default useDefaultAmountForReplenishment;
